module.exports = __webpack_public_path__ + "./docs/img/icon-getter.c5afaf847af6e1981c8c9e9a889dcd3d.svg";